<template>
  <div class="summaryFinancial">
    <div style="display: flex">
      <el-popover
        v-if="isOperator"
        placement="bottom"
        width="150"
        :disabled="disabled1"
        trigger="hover"
        @show="show1"
      >
        <div
          style="display: flex; justify-content: center;cursor: pointer"
          @click="getPageData('DAY')"
        >
          今日财务
        </div>
        <div
          style="display: flex; justify-content: center; margin-top: 10px;cursor: pointer"
          @click="getPageData('MONTH')"
        >
          本月财务
        </div>
        <div
          style="display: flex; justify-content: center; margin-top: 10px;cursor: pointer"
          @click="getPageData('YEAR')"
        >
          本年财务
        </div>
        <div
          style="display: flex; justify-content: center; margin-top: 10px;cursor: pointer"
          @click="showDate"
        >
          自定义时间
        </div>
        <el-button
          slot="reference"
          type="text"
          :style="style1"
          @click="isSelect1"
        >电站运营商</el-button>
      </el-popover>
      <el-popover
        v-if="isCar"
        placement="bottom"
        width="150"
        :disabled="disabled2"
        trigger="hover"
        @show="show2"
      >
        <div
          style="display: flex; justify-content: center;cursor: pointer"
          @click="getPageData('DAY')"
        >
          今日财务
        </div>
        <div
          style="display: flex; justify-content: center; margin-top: 10px;cursor: pointer"
          @click="getPageData('MONTH')"
        >
          本月财务
        </div>
        <div
          style="display: flex; justify-content: center; margin-top: 10px;cursor: pointer"
          @click="getPageData('YEAR')"
        >
          本年财务
        </div>
        <div
          style="display: flex; justify-content: center; margin-top: 10px;cursor: pointer"
          @click="showDate"
        >
          自定义时间
        </div>
        <el-button
          slot="reference"
          type="text"
          :style="style2"
          @click="isSelect2"
        >车辆机构</el-button>
      </el-popover>
      <el-popover
        v-if="isFlow"
        placement="bottom"
        width="150"
        trigger="hover"
        @show="show3"
      >
        <div
          style="display: flex; justify-content: center; cursor: pointer;"
          @click="getPageData('DAY')"
        >
          今日财务
        </div>
        <div
          style="display: flex; justify-content: center; margin-top: 10px;cursor: pointer;"
          @click="getPageData('MONTH')"
        >
          本月财务
        </div>
        <div
          style="display: flex; justify-content: center; margin-top: 10px;cursor: pointer"
          @click="getPageData('YEAR')"
        >
          本年财务
        </div>
        <div
          style="display: flex; justify-content: center; margin-top: 10px;cursor: pointer"
          @click="showDate"
        >
          自定义时间
        </div>
        <el-button
          slot="reference"
          type="text"
          style="color: #409eff; border-bottom: 2px solid #409eff; width: 150px"
        >流量方</el-button>
      </el-popover>
      <el-form
        v-if="customTime"
        :model="queryForm"
        label-width="120px"
        style="margin-left: 100px"
      >
        <div style="display: flex">
          <el-form-item label="自定义时间">
            <el-date-picker
              v-model="queryForm.startTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
              :clearable="false"
            />
          </el-form-item>
          <el-form-item label="至">
            <el-date-picker
              v-model="queryForm.endTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
              :clearable="false"
            />
          </el-form-item>
          <el-form-item label=" " label-width="20px">
            <el-button type="primary" @click="getPageData()">查询</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="box">
      <div style="width: 16%">
        <div style="display: flex; align-items: center; justify-content: center;">
          <i class="iconfont icon-iconset0216" />
          <span
            style="font-size: 17px; color: #333333; margin-left: 6px"
          >充电量（度）</span>
        </div>
        <div>
          <span class="moneyNum" :title="detail.totalChargingDegree">{{
            getFloat(detail.totalChargingDegree)
          }}</span>
          <!-- <span style="font-size: 14px; color: #333333">度</span> -->
        </div>
      </div>
      <template v-if="type == 0">
        <div style="width: 16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-dianfei" style="color: #00a6ff" />
            <span
              style="font-size: 17px; color: #333333; margin-left: 6px"
            >电费（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.totalElectricityBill">{{
              getFloat(detail.totalElectricityBill)
            }}</span>
            <!-- <span style="font-size: 14px; color: #333333">元</span> -->
          </div>
        </div>
        <div style="width: 16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-fuwufei" style="color: #00a6ff" />
            <span
              style="font-size: 17px; color: #333333; margin-left: 6px"
            >服务费（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.totalServiceCharge">{{
              getFloat(detail.totalServiceCharge)
            }}</span>
            <!-- <span style="font-size: 14px; color: #333333">元</span> -->
          </div>
        </div>
        <div style="width: 16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-yingshouzhangkuan" />
            <span
              style="font-size: 17px; color: #333333; margin-left: 6px"
            >应收金额（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.totalPayableAmount">{{
              getFloat(detail.totalPayableAmount)
            }}</span>
            <!-- <span style="font-size: 14px; color: #333333">元</span> -->
          </div>
        </div>
        <div style="width: 16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-lirunbiao" />
            <span
              style="font-size: 17px; color: #333333; margin-left: 6px"
            >实收核对（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.totalAmountReceivable">{{
              getFloat(detail.totalAmountReceivable)
            }}</span>
            <!-- <span style="font-size: 14px; color: #333333">元</span> -->
          </div>
        </div>
        <div style="width: 16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-shishoufeiyong" style="color: #f4ea2a" />
            <span
              style="font-size: 17px; color: #333333; margin-left: 6px"
            >实收金额（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.totalActualAmount">{{
              getFixed2(detail.totalActualAmount)
            }}</span>
            <!-- <span style="font-size: 14px; color: #333333">元</span> -->
          </div>
        </div>
      </template>
      <template v-if="type == 1">
        <div style="width: 16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-yingshouzhangkuan" />
            <span
              style="font-size: 17px; color: #333333; margin-left: 6px"
            >应付金额（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.totalPayableAmount">{{
              getFloat(detail.totalPayableAmount)
            }}</span>
            <!-- <span style="font-size: 14px; color: #333333">元</span> -->
          </div>
        </div>
        <div style="width: 16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-shishoufeiyong" style="color: #f4ea2a" />
            <span
              style="font-size: 17px; color: #333333; margin-left: 6px"
            >实付核对（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.totalAmountReceivable">{{
              getFloat(detail.totalAmountReceivable)
            }}</span>
            <!-- <span style="font-size: 14px; color: #333333">元</span> -->
          </div>
        </div>
        <div style="width: 16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-lirunbiao" />
            <span
              style="font-size: 17px; color: #333333; margin-left: 6px"
            >实付金额（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.totalActualAmount">{{
              getFixed2(detail.totalActualAmount)
            }}</span>
            <!-- <span style="font-size: 14px; color: #333333">元</span> -->
          </div>
        </div>
        <div style="width: 16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-qianbao" />
            <span
              style="font-size: 17px; color: #333333; margin-left: 6px"
            >企业钱包余额（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.unitBalance">{{
              getFixed2(detail.unitBalance)
            }}</span>
            <!-- <span style="font-size: 14px; color: #333333">元</span> -->
          </div>
        </div>
        <div style="width: 16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-qianbao1" />
            <span
              style="font-size: 17px; color: #333333; margin-left: 6px"
            >个人钱包余额（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.personalBalance">{{
              getFixed2(detail.personalBalance)
            }}</span>
            <!-- <span style="font-size: 14px; color: #333333">元</span> -->
          </div>
        </div>
      </template>
      <template v-if="type == 2">
        <div style="width: 16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-dianfei" style="color: #00a6ff" />
            <span
              style="font-size: 17px; color: #333333; margin-left: 6px"
            >电费（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.totalElectricityBill">{{
              getFloat(detail.totalElectricityBill)
            }}</span>
            <!-- <span style="font-size: 14px; color: #333333">元</span> -->
          </div>
        </div>
        <div style="width: 16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-fuwufei" style="color: #00a6ff" />
            <span
              style="font-size: 17px; color: #333333; margin-left: 6px"
            >服务费（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.totalServiceCharge">{{
              getFloat(detail.totalServiceCharge)
            }}</span>
            <!-- <span style="font-size: 14px; color: #333333">元</span> -->
          </div>
        </div>
        <div style="width: 16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-yingshouzhangkuan" />
            <span
              style="font-size: 17px; color: #333333; margin-left: 6px"
            >应收金额（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.totalPayableAmount">{{
              getFloat(detail.totalPayableAmount)
            }}</span>
            <!-- <span style="font-size: 14px; color: #333333">元</span> -->
          </div>
        </div>
        <div style="width: 16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-qianbao" />
            <span
              style="font-size: 17px; color: #333333; margin-left: 6px"
            >企业钱包余额（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.unitBalance">{{
              getFixed2(detail.unitBalance)
            }}</span>
            <!-- <span style="font-size: 14px; color: #333333">元</span> -->
          </div>
        </div>
        <div style="width: 16%">
          <div>
            <i class="iconfont icon-qianbao1" />
            <span
              style="font-size: 17px; color: #333333; margin-left: 6px"
            >个人钱包余额（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.personalBalance">{{
              getFixed2(detail.personalBalance)
            }}</span>
            <!-- <span style="font-size: 14px; color: #333333">元</span> -->
          </div>
        </div>
      </template>
    </div>
    <template>
      <el-table :data="tableData" stripe border style="width: 100%">
        <el-table-column type="index" align="center" width="50" label="序号" />
        <el-table-column label="企业名称" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="goToDetail(scope.row)"
            >{{ scope.row.companyName }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="充电度数" align="center">
          <template slot-scope="scope">
            <span>{{ getFloat(scope.row.totalPower) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="电费" align="center">
          <template slot-scope="scope">
            <span>{{ getFloat(scope.row.elecMoney) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="服务费" align="center">
          <template slot-scope="scope">
            <span>{{ getFloat(scope.row.seviceMoney) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="应付金额" align="center">
          <template slot-scope="scope">
            <span>{{ getFloat(scope.row.totalMoneyRec) }}</span>
          </template>
        </el-table-column> -->
        <template v-if="type == 0">
          <el-table-column label="应收金额" align="center">
            <template slot-scope="scope">
              <span>{{ getFloat(scope.row.totalMoney) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实收核对" align="center">
            <template slot-scope="scope">
              <span>{{ getFloat(scope.row.totalMoneyCheck) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实收金额" align="center">
            <template slot-scope="scope">
              <span>{{ getFixed2(scope.row.totalMoneyActual) }}</span>
            </template>
          </el-table-column>
        </template>
        <template v-else-if="type == 1 || type == 2">
          <el-table-column label="应付金额" align="center">
            <template slot-scope="scope">
              <span>{{ getFloat(scope.row.totalMoney) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实付核对" align="center">
            <template slot-scope="scope">
              <span>{{ getFloat(scope.row.totalMoneyCheck) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实付金额" align="center">
            <template slot-scope="scope">
              <span>{{ getScaleNum(scope.row.totalMoneyActual, 2) }}</span>
            </template>
          </el-table-column>
                    <el-table-column label="企业钱包余额（元）" align="center">
            <template slot-scope="scope">
              <span>{{ getFixed2(scope.row.unitBalance) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="个人钱包余额（元）" align="center">
            <template slot-scope="scope">
              <span>{{ getFixed2(scope.row.personalBalance) }}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </template>
    <!-- <div style="float: left;" v-if="pageshow">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
  </div> -->
  </div>
</template>

<script>
export default {
  name: 'Caiwugaikuang',
  components: {},
  data() {
    return {
      queryForm: {
        startTime: '',
        endTime: ''
      },
      activeName: '',
      detail: {},
      tableData: [],
      currentPage: 1, // 当前页
      total: 0, // 总页数
      pagesize: 10, // 每页条数
      pageshow: true,
      style1: 'color: #409eff; border-bottom:2px solid #409eff; width: 150px;',
      style2: 'color: #C0C4CC; width: 150px;',
      disabled1: false,
      disabled2: true,
      isOperator: true,
      isCar: false,
      isFlow: false,
      customTime: false,
      type: 0,
      failDetail: {}
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.getPageData('DAY')
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    isSelect1() {
      this.style1 =
        'color: #409eff; border-bottom:2px solid #409eff; width: 150px;'
      this.style2 = 'color: #C0C4CC; width: 150px;'
      this.disabled1 = false
      this.disabled2 = true
      this.type = 0
      this.detail = this.failDetail.stationResp
      if (this.failDetail.stationResp.overviewList.length > 0) {
        this.tableData = this.failDetail.stationResp.overviewList
        this.total = this.failDetail.stationResp.count
        this.pageshow = true
      } else {
        this.pageshow = false
        this.tableData = []
      }
      console.log(this.tableData, 'ttttt')
    },
    isSelect2() {
      this.style1 = 'color: #C0C4CC; width: 150px;'
      this.style2 =
        'color: #409eff; border-bottom:2px solid #409eff; width: 150px;'
      this.disabled1 = true
      this.disabled2 = false
      this.type = 1
      this.detail = this.failDetail.accountResp
      if (this.failDetail.accountResp.overviewList.length > 0) {
        this.tableData = this.failDetail.accountResp.overviewList
        this.total = this.failDetail.accountResp.count
        this.pageshow = true
      } else {
        this.pageshow = false
        this.tableData = []
      }
    },

    handleSizeChange(val) {
      this.pagesize = val
      this.selecttable()
    },

    handleCurrentChange(val) {
      this.pageshow = false
      this.currentPage = val
      this.selecttable()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    show1() {
      console.log('11111111')
    },
    show2() {
      console.log('22222222')
    },
    show3() {
      console.log('33333333')
    },
    showDate() {
      this.customTime = true
    },
    getPageData(val) {
      if (val) {
        this.customTime = false
        this.queryForm = {
          startTime: '',
          endTime: ''
        }
      }
      const data = {
        pageNo: this.currentPage,
        pageSize: this.pagesize,
        timeType: val,
        startTime: this.queryForm.startTime,
        endTime: this.queryForm.endTime
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/manage',
        data: data,
        method: 'get',
        callback: (resp) => {
          if (resp.orgType === 0) {
            this.type = 0
            this.detail = resp.stationResp
            this.isOperator = true
            this.isFlow = false
            this.isCar = false
            if (resp.stationResp.overviewList.length > 0) {
              this.tableData = resp.stationResp.overviewList
              this.total = resp.stationResp.count
              this.pageshow = true
            } else {
              this.tableData = []
              this.pageshow = false
            }
          } else if (resp.orgType === 1 || resp.orgType === 2) {
            this.detail = resp.accountResp
            if (resp.orgType === 1) {
              this.style2 =
                'color: #409eff; border-bottom:2px solid #409eff; width: 150px;'
              this.disabled1 = true
              this.disabled2 = false
              this.type = 1
              this.isCar = true
              this.isOperator = false
              this.isFlow = false
            } else if (resp.orgType === 2) {
              this.type = 2
              this.isCar = false
              this.isOperator = false
              this.isFlow = true
            }
            if (resp.accountResp.overviewList.length > 0) {
              this.tableData = resp.accountResp.overviewList
              this.total = resp.accountResp.count
              this.pageshow = true
            } else {
              this.tableData = []
              this.pageshow = false
            }
          } else if (resp.orgType === 3) {
            this.isOperator = true
            this.isCar = true
            this.isFlow = false
            this.failDetail = resp
            if (this.type === 0) {
              this.detail = resp.stationResp
              if (resp.stationResp.overviewList.length > 0) {
                this.tableData = resp.stationResp.overviewList
                this.total = resp.stationResp.count
                this.pageshow = true
              } else {
                this.pageshow = false
                this.tableData = []
              }
            } else {
              this.detail = resp.accountResp
              if (resp.accountResp.overviewList.length > 0) {
                this.tableData = resp.accountResp.overviewList
                this.total = resp.accountResp.count
                this.pageshow = true
              } else {
                this.pageshow = false
                this.tableData = []
              }
            }
          }
        }
      })
    },

    goToDetail(item) {
      if (this.isFlow === true) {
        // 流量方
        this.$router.push({ path: './flowDetail', query: { data: item.id }})
      } else if (this.isOperator === true && this.disabled1 === false) {
        // 电站运营商
        this.$router.push({
          path: './summaryDetailFinancial',
          query: { data: item.id }
        })
      } else if (this.isCar === true && this.disabled2 === false) {
        // 车辆机构
        this.$router.push({ path: './carDetail', query: { data: item.id }})
      }
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" >
.summaryFinancial {
  .el-form-item__label {
    text-align: center !important;
  }
  .el-form-item:nth-of-type(2) {
    .el-form-item__label {
      width: 40px !important;
    }
    .el-form-item__content {
      margin-left: 40px !important;
    }
  }
  .box {
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 40px;
    padding: 0 20px;
    .moneyNum {
      font-size:26px;
      padding-top: 10px;
      color: #1890ff;
      font-weight: 500;
      max-width: 100%;
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    div {
      text-align: center;
      .iconfont {
        font-size: 28px;
        font-weight: 600;
      }

      .icon-iconset0216 {
        color: #32f83e;
      }

      .icon-lirunbiao {
        color: #f2e743;
      }
      .icon-yingshouzhangkuan {
        color: #f2e743;
        font-size: 24px;
      }

      .icon-qianbao {
        color: #409eff;
      }

      .icon-qianbao1 {
        color: #409eff;
        font-size: 24px;
      }
      .icon-yingshouzhangkuan {
        font-size: 26px;
      }
      .icon-shishoufeiyong {
        font-size: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ticketManagement/summaryFinancial.vue